var map = {
	"./Ellipse 21.svg": 90020,
	"./account-active.svg": 51569,
	"./account-login.svg": 94962,
	"./account.svg": 23602,
	"./activities-active.svg": 96717,
	"./activities-card-1.svg": 63567,
	"./activities-card-2.svg": 892,
	"./activities-card-3.svg": 74013,
	"./activities-card-4.svg": 40082,
	"./activities.svg": 9718,
	"./add-person.svg": 25332,
	"./add.svg": 2021,
	"./arrow-down.svg": 40649,
	"./avatar-3.svg": 52846,
	"./awatar.svg": 847,
	"./change-awatar.svg": 53716,
	"./charge-index.svg": 63674,
	"./clock.svg": 54117,
	"./code.svg": 37478,
	"./copy-2.svg": 38815,
	"./copy.svg": 78838,
	"./cost-active.svg": 60829,
	"./cost-card-1.svg": 48415,
	"./cost-card-2.svg": 69388,
	"./cost-card-3.svg": 68333,
	"./cost-card-4.svg": 98114,
	"./cost-index.svg": 17257,
	"./cost.svg": 8486,
	"./customer-1.svg": 92391,
	"./customer-2.svg": 44180,
	"./customer-3.svg": 16789,
	"./customer-4.svg": 93578,
	"./customer-active.svg": 57608,
	"./customer.svg": 93509,
	"./data-analysis-active.svg": 45315,
	"./data-analysis-card-1.svg": 70573,
	"./data-analysis-card-2.svg": 41454,
	"./data-analysis-card-3.svg": 46207,
	"./data-analysis-card-4.svg": 4000,
	"./data-analysis.svg": 89984,
	"./data-count-1.svg": 5077,
	"./data-count-2.svg": 16854,
	"./data-count-3.svg": 80679,
	"./data-count-4.svg": 7848,
	"./days.svg": 7972,
	"./delete-2.svg": 16797,
	"./delete.svg": 94928,
	"./down-green.svg": 64875,
	"./down-red.svg": 47303,
	"./download.svg": 15253,
	"./e-email.svg": 63981,
	"./e-send.svg": 34309,
	"./e-signature.svg": 79183,
	"./edit-blue.svg": 61530,
	"./edit-white.svg": 74113,
	"./edit.svg": 95869,
	"./email-2.svg": 75054,
	"./email-active.svg": 34386,
	"./email.svg": 39083,
	"./end-date.svg": 73105,
	"./export-white.svg": 899,
	"./export.svg": 65475,
	"./finance-index.svg": 90886,
	"./import.svg": 8454,
	"./index-active.svg": 32442,
	"./index.svg": 74979,
	"./infomation-active.svg": 23056,
	"./infomation.svg": 69245,
	"./invoice-active.svg": 47117,
	"./invoice-card-1.svg": 76911,
	"./invoice-card-2.svg": 97884,
	"./invoice-card-3.svg": 52157,
	"./invoice-card-4.svg": 18226,
	"./invoice-index.svg": 27801,
	"./invoice.svg": 63414,
	"./msg-index.svg": 91899,
	"./notice-active.svg": 14756,
	"./notice-index.svg": 55218,
	"./notice-stroke-index.svg": 60557,
	"./notice.svg": 89881,
	"./order-active.svg": 3806,
	"./order.svg": 80431,
	"./password.svg": 39902,
	"./pay-index.svg": 73850,
	"./phone.svg": 37755,
	"./plus-fill.svg": 26289,
	"./quick-index-1.svg": 83783,
	"./quick-index-2.svg": 12276,
	"./quick-index-3.svg": 37909,
	"./quick-index-4.svg": 27498,
	"./quotation-active.svg": 75503,
	"./quotation-card-1.svg": 70606,
	"./quotation-card-2.svg": 81325,
	"./quotation-card-3.svg": 45868,
	"./quotation-card-4.svg": 86259,
	"./quotation.svg": 56449,
	"./receipt-active.svg": 91086,
	"./receipt.svg": 28479,
	"./rule-index.svg": 69212,
	"./schedule-index.svg": 31225,
	"./search.svg": 58217,
	"./serve-index-1.svg": 24219,
	"./serve-index-2.svg": 42856,
	"./serve-index-3.svg": 67129,
	"./service-active.svg": 78929,
	"./service.svg": 59922,
	"./staff-active.svg": 80816,
	"./staff-add.svg": 32111,
	"./staff-index.svg": 12838,
	"./staff-list-awatar.svg": 47717,
	"./staff-search.svg": 99650,
	"./staff.svg": 28221,
	"./star.svg": 48637,
	"./success.svg": 51530,
	"./supplier-active.svg": 38560,
	"./supplier-index.svg": 91894,
	"./supplier.svg": 79085,
	"./system-active.svg": 27725,
	"./system-index.svg": 21497,
	"./system.svg": 14518,
	"./trumpet-index.svg": 45907,
	"./up-green.svg": 65904,
	"./up-red.svg": 90928,
	"./upload.svg": 29538,
	"./white-add.svg": 61666,
	"./zhaidian-index.svg": 7274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;